export default {
    gatherApprovedReviews(assignments) {
        let reviews = [];

        for (const assignment of assignments) {
            if (assignment.status !== "Approved" && assignment.status !== "ActionRequested" && assignment.status !== "ActionApproved" && assignment.status !== "PendingApproval" && assignment.status !== "Archived") {
                continue;
            }

            if (assignment.status === "CouldNotVerify") {
                continue;
            }

            if (!assignment.review || (assignment.review.status !== "Approved" && assignment.review.status !== "PendingApproval")) {
                continue;
            }

            assignment.review.assignment = assignment;

            reviews.push(assignment.review);
        }

        return reviews;
    },

    gatherVisibleAssignments(assignments) {
        const visibleAssignments = [];

        for (const assignment of this.$store.state.assignments) {
            if (assignment.status === "Assigned" || assignment.status === "Waiting" || assignment.status === "CouldNotVerify") {
                activeCount++;
            }
        }

        return visibleAssignments;
    },

    gatherOpenAssignments(assignments) {
        const visibleAssignments = [];

        // Group all Assigned assignments before the Open assignments.
        for (const assignment of assignments) {
            if (assignment.status === "Assigned") {
                visibleAssignments.push(assignment);
            }
        }
        for (const assignment of assignments) {
            if (assignment.status === "Open") {
                visibleAssignments.push(assignment);
            }
        }
        for (const assignment of assignments) {
            if (assignment.status === "HoldingUnproven") {
                visibleAssignments.push(assignment);
            }
        }

        return visibleAssignments;
    }
}